export interface TableFilters {
    [prop: string]: any;
}

export class TableFiltersSelection {
    private readonly _f: TableFilters;

    constructor(filters: TableFilters) {
        this._f = filters;
    }

    get filters(): TableFilters {
        return this._f ? this._f : {};
    }

    add(filters: TableFilters): TableFiltersSelection {
        for (const prop in filters) {
            if (filters[prop]) {
                this._f[prop] = filters[prop];
            }
        }

        return this;
    }

    remove(prop: string): TableFiltersSelection {
        if (this._f[prop]) {
            delete this._f[prop];
        }

        return this;
    }

    toggle(filters: TableFilters): TableFiltersSelection {
        for (const prop in filters) {
            if (filters[prop]) {
                if (this._f[prop]) {
                    delete this._f[prop];
                } else {
                    this._f[prop] = filters[prop];
                }
            }
        }

        return this;
    }
}
